import axios from '@/plugins/axios';

export default {

  getSenders() {
    return axios.httpApi.get('phone_senders', { params: { limit: 99 } });
  },
  searchTemplates(sender) {
    return axios.httpApi.get(`whatsapp_meta/${sender.phone_number}/template`,
      {
        params: { waba_id: sender.meta_waba_id }
      });
  },
};
